import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Header } from "./Schools";
import { StatusPill } from "./Overview";

export default function Bookings() {
  const [items, setItems] = useState([]);
  const load = () => api.get("/bookings").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);
  const update = async (id, status) => {
    const fd = new FormData(); fd.append("status", status);
    await api.put(`/bookings/${id}/status`, fd);
    toast.success(`Booking ${status}`); load();
  };
  const remove = async (id) => {
    if (!window.confirm("Delete this booking? This cannot be undone.")) return;
    try {
      await api.delete(`/bookings/${id}`);
      toast.success("Booking deleted");
      load();
    } catch { toast.error("Failed to delete"); }
  };
  return (
    <div className="fade-up">
      <Header title="Bookings" subtitle="Review and manage training requests." />
      <div className="mt-6 rounded-2xl border border-gray-200 bg-white overflow-hidden">
        <div className="overflow-x-auto">
        <table className="w-full text-sm min-w-[720px]">
          <thead className="bg-gray-50 text-xs uppercase tracking-wider text-gray-500">
            <tr><th className="text-left px-5 py-3 font-medium">School</th><th className="text-left px-5 py-3 font-medium">Contact</th><th className="text-left px-5 py-3 font-medium">Date</th><th className="text-left px-5 py-3 font-medium">Teachers</th><th className="text-left px-5 py-3 font-medium">Status</th><th className="text-right px-5 py-3 font-medium">Actions</th></tr>
          </thead>
          <tbody>
            {items.map((b) => (
              <tr key={b.id} className="border-t border-gray-100 hover:bg-gray-50">
                <td className="px-5 py-3 font-medium">{b.school_name}</td>
                <td className="px-5 py-3 text-gray-600">
                  <div>{b.contact_name}</div>
                  <div className="text-xs text-gray-500">{b.contact_email}</div>
                </td>
                <td className="px-5 py-3">{b.preferred_date}</td>
                <td className="px-5 py-3">{b.teacher_count}</td>
                <td className="px-5 py-3"><StatusPill s={b.status} /></td>
                <td className="px-5 py-3 text-right">
                  <div className="inline-flex gap-2">
                    <button onClick={() => update(b.id, "approved")} data-testid={`approve-${b.id}`} className="text-xs px-2.5 py-1 rounded-lg bg-emerald-50 text-emerald-700 hover:bg-emerald-100">Approve</button>
                    <button onClick={() => update(b.id, "rejected")} data-testid={`reject-${b.id}`} className="text-xs px-2.5 py-1 rounded-lg bg-red-50 text-red-700 hover:bg-red-100">Reject</button>
                    <button onClick={() => update(b.id, "completed")} data-testid={`complete-${b.id}`} className="text-xs px-2.5 py-1 rounded-lg bg-indigo-50 text-indigo-700 hover:bg-indigo-100">Complete</button>
                    <button onClick={() => remove(b.id)} data-testid={`delete-${b.id}`} className="text-xs px-2.5 py-1 rounded-lg bg-gray-100 text-gray-600 hover:bg-rose-100 hover:text-rose-700">Delete</button>
                  </div>
                </td>
              </tr>
            ))}
            {items.length === 0 && <tr><td colSpan="6" className="text-center py-10 text-gray-500">No bookings yet.</td></tr>}
          </tbody>
        </table>
        </div>
      </div>
    </div>
  );
}
